export const LOCAL =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const PRODUCTION = window.env.env === 'prod';

export const LOAD_SMARTLOOK_SCRIPTS = PRODUCTION;

export const LOAD_EVENT_TRACKING_SCRIPTS = window.env.env === 'prod' || window.env.env === 'stage'; // remove 'stage' after release
